import { render } from "./bill-by-detail.vue?vue&type=template&id=0a7a0a92&scoped=true&ts=true"
import script from "./bill-by-detail.vue?vue&type=script&lang=ts"
export * from "./bill-by-detail.vue?vue&type=script&lang=ts"

import "./bill-by-detail.vue?vue&type=style&index=0&id=0a7a0a92&scoped=true&lang=stylus"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7a0a92"]])

export default __exports__